export default "__VITE_ASSET__e1e67e37__"